import { render, staticRenderFns } from "./fbPixelAccessToken.vue?vue&type=template&id=48aa2c7b&"
import script from "./fbPixelAccessToken.vue?vue&type=script&lang=js&"
export * from "./fbPixelAccessToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports